import React from "react";
import FHIRDetails from "../FHIRDetails";
import Icon from "../Icon";
import Tabs from "../Tabs";
import MembershipHistory from "../../routes/NewSearchRecords/SearchRecordTable/MembershipHistory.js";
import ImdmMembershipHistory from "../../routes/NewSearchRecords/SearchRecordTable/ImdmMembershipHistory";
import RecordHistory from "../../routes/NewSearchRecords/SearchRecordTable/RecordHistory";
import { isImdmClient } from "../../utils/isImdmClient";
import { useAuthState } from "../AuthProvider";

import styles from "./FHIRRecordDetails.module.scss";

export const FHIRRecordDetails = ({
  patientRecordDetails,
  quarantineRecordDetails,
  membershipHistoryDetails,
  recordHistory,
  onCloseClick,
  oncRecordOverrideIconClick,
  defaultRecordHistoryTab = false,
  recordId,
  className,
  isNewQuarantine,
  nameToTypeMap
}) => {
  const { user } = useAuthState();
  const { selectedClient } = user.preferences;
  let isImdm = isImdmClient(selectedClient);
  const entityId = recordId.split("+")[0];
  const sourceId = recordId.split("+")[1];

  const tabsBuilder = [
    <Tabs.Panel label="Record Details">
      <FHIRDetails
        patient={patientRecordDetails}
        oncRecordOverrideIconClick={detailsMap =>
          oncRecordOverrideIconClick(detailsMap, patientRecordDetails)
        }
        isNewQuarantine={isNewQuarantine}
      />
    </Tabs.Panel>,
    <Tabs.Panel label="Membership History">
      {membershipHistoryDetails.membershipDetails &&
      membershipHistoryDetails.membershipDetails.length > 0 ? (
        <MembershipHistory data={membershipHistoryDetails.membershipDetails} />
      ) : (
        <div className={styles.noDetails}>{"No Membership History found"}</div>
      )}
    </Tabs.Panel>,
    <Tabs.Panel label="Record History">
      {(recordHistory && recordHistory.length > 0) ||
      (isNewQuarantine && quarantineRecordDetails) ? (
        <RecordHistory
          history={recordHistory}
          currentRecord={patientRecordDetails}
          isNewQuarantine={isNewQuarantine}
          entityId={entityId}
          sourceId={sourceId}
          nameToTypeMap={nameToTypeMap}
        />
      ) : (
        <div className={styles.noDetails}>{"No Record History found"}</div>
      )}
    </Tabs.Panel>
  ];

  if (isImdm) {
    tabsBuilder.push(
      <Tabs.Panel label="IMDM Membership History">
        {membershipHistoryDetails.imdmMembershipDetails &&
        membershipHistoryDetails.imdmMembershipDetails.length > 0 ? (
          <ImdmMembershipHistory
            data={membershipHistoryDetails.imdmMembershipDetails}
          />
        ) : (
          <div className={styles.noDetails}>
            {"No Imdm Membership History found"}
          </div>
        )}
      </Tabs.Panel>
    );
  }

  return (
    <div className={styles.base + " " + className}>
      <Tabs
        defaultSelectedIndex={defaultRecordHistoryTab === true ? 2 : 0}
        className={styles.tabs}
      >
        {tabsBuilder.map(val => val)}
      </Tabs>
      <button
        className={styles.closeButton}
        onClick={() => {
          onCloseClick(recordId, membershipHistoryDetails.table);
        }}
      >
        <Icon type="remove" />
      </button>
    </div>
  );
};
